import React from 'react';
import PropTypes from 'prop-types';
import PreferencesSection from '../PreferencesSection';
import Icon from 'SF/MaterialIcon';
import css from './StaffEmailPreferences.scss';
import { StaffProfileData } from 'utils/types';
import StaffEmail from "./StaffEmail";
import { isValidEmail } from "utils/text";
import { getWord } from "utils/tenant";
import classnames from "classnames";

const StaffEmailPreferences = ({ profile, setValue, goToProfileDetails }) => {

    const getHeader = () => (
        <span><Icon icon="mail_outline" aria-hidden={true} />Email Notifications</span>
    );

    const getSupplementalInfo = () => {
        return (
            <p>
                You will receive emails about {getWord('Starfish')} activity, such as appointment reminders
                and {getWord('tracker', true)} item updates, depending on your institution’s settings and your preferences.
            </p>
        );
    };

    const handleOptInChange = (checked, correspondenceEmail, otherEmail) => {
        if (checked) {
            setValue({ correspondenceTo: profile.correspondenceTo === otherEmail ? 'BOTH_MAIL' : correspondenceEmail });
        } else {
            setValue({ correspondenceTo: profile.correspondenceTo === 'BOTH_MAIL' ? otherEmail : '' });
        }
    };

    const isChecked = (correspondenceEmail) => {
        return profile.correspondenceTo === 'BOTH_MAIL' || profile.correspondenceTo === correspondenceEmail;
    };

    const getEmailSelector = () => {
        return (
            <>
                <div className={css['informational-text']}>
                    <p className={classnames({[css.error]: profile.correspondenceTo === ''})} >
                        {profile.correspondenceTo === '' && <Icon icon="error" aria-hidden={true} className={css['icon-error']}/>}
                        Select <span className={css['emphasized-text']}>at least</span> one email address you want to receive notifications.
                    </p>
                    {getSupplementalInfo()}
                </div>
                <StaffEmail id="schoolEmail"
                            isChecked={isChecked('SCHOOL_MAIL')}
                            isError={profile.correspondenceTo === ''}
                            customLabel="institutionEmail"
                            email={profile.schoolEmail}
                            handleOptInChange={(checked) => handleOptInChange(checked, 'SCHOOL_MAIL', 'PREFERRED_MAIL')} />
                <StaffEmail id="alternateEmail"
                            isChecked={isChecked('PREFERRED_MAIL')}
                            isError={profile.correspondenceTo === ''}
                            email={profile.preferredEmail}
                            customLabel="alternateEmail"
                            handleOptInChange={(checked) => handleOptInChange(checked, 'PREFERRED_MAIL', 'SCHOOL_MAIL')} />
            </>
        );
    };

    const getInstitutionalEmail = () => {
        return (
            <>
                <div>
                    <p className={css['label-text']}>
                        Send to my {getWord("institutionEmail")}:
                    </p>
                    <p className={css['email']} data-testid="schoolEmail">{profile.schoolEmail}</p>
                </div>
                <div className={css['informational-text']}>
                    <p className={css['alternate-email']}>
                        You can <a href="#" onClick={goToProfileDetails}>provide
                        a valid {getWord('alternateEmail', true)}</a> to receive notifications
                        to a preferred inbox.
                    </p>
                    {getSupplementalInfo()}
                </div>
            </>
        );
    };

    return (
        <PreferencesSection headerText={getHeader()}>
            {isValidEmail(profile.preferredEmail) ? getEmailSelector() : getInstitutionalEmail()}
        </PreferencesSection>
    );
};

StaffEmailPreferences.propTypes = {
    profile: StaffProfileData.isRequired,
    setValue: PropTypes.func.isRequired,
    goToProfileDetails: PropTypes.func.isRequired
};

export default StaffEmailPreferences;
